// export const API = "https://edirne-loko-maintenance.herokuapp.com";
export const API = "https://edirne-karabuk-onboard.onrender.com/edirne";